<freud-loader
	class="loading"
	*ngIf="loading"
	size="lg"
	[bgColor]="false"
></freud-loader>

<vc-jitsi *ngIf="!loading" [appointment]="appointment"></vc-jitsi>

<vc-switch
	*ngIf="!loading"
	[appointment]="appointment"
	[placement]="switchPlacement"
	(displayStateChange)="displayStateChange($event)"
></vc-switch>

<vc-sidebar
	*ngIf="!loading && displayState === 'sidebar'"
	[appointment]="appointment"
	(displayStateChange)="displayStateChange($event)"
></vc-sidebar>
